import BlogPage from "./components/blog/BlogPage";
import SingleBlogPage from "./components/blog/SingleBlogPage";
import { HelmetProvider } from "react-helmet-async";
import { Routes, Route } from "react-router-dom";
import WebsiteSection from "./components/WebsiteSection";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FeaturesSection from "./components/FeaturesSection";
import PriceSection from "./components/priceSection/PriceSection";
import PartnershipSection from "./components/PartnershipSection";
import BookingSystemSection from "./components/BookingSystemSection";
import EmbeddedSection from "./components/EmbeddedSection";
import EbookPage from "./components/EbookPage";
import Offer from "./components/offer/Offer";
import GroupBookingLanding from "./components/GroupBookingLanding";
import MainPage from "./components/mainPage/MainPage";
import DynamicLanding from "./components/forWhoLandingPages/DynamicLanding";
import { gymContent } from "./components/forWhoLandingPages/gymContent";
import { horseContent } from "./components/forWhoLandingPages/horseContent";
import { cosmeticsContent } from "./components/forWhoLandingPages/cosmeticsContent";
import { workshopContent } from "./components/forWhoLandingPages/workshopContent";
import { massageContent } from "./components/forWhoLandingPages/massageContent";
import { dogGroomingContent } from "./components/forWhoLandingPages/dogGroomingContent";
import NotFoundPage from "./components/NotFoundPage";
import WobbleStartLanding from "./components/WobbleStartLanding";
import VideoPage from "./components/VideoPage";
// import LandingPageSection from "./components/LandingPageSection";

function App() {

  return (
    <HelmetProvider>
      <Navbar />
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/funkciok" element={<FeaturesSection />} />
        <Route
          path="/online-idopontfoglalo"
          element={<BookingSystemSection />}
        />
        {/* <Route path="/landing-oldal" element={<LandingPageSection />} /> */}
        <Route path="/weboldal" element={<WebsiteSection />} />
        <Route path="/csomagok" element={<PriceSection />} />
        <Route path="/partner" element={<PartnershipSection />} />
        <Route path="/beagyazas" element={<EmbeddedSection />} />
        <Route path="/videok" element={<VideoPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:title" element={<SingleBlogPage />} />
        <Route path="/ebook" element={<EbookPage />} />
        <Route path="/ajanlat" element={<Offer />} />
        <Route path="/start" element={<WobbleStartLanding />} />

        <Route path="/csoportos-foglalas" element={<GroupBookingLanding />} />
        <Route
          path="/edzok"
          element={<DynamicLanding content={gymContent} />}
        />
        <Route
          path="/lovardak"
          element={<DynamicLanding content={horseContent} />}
        />
        <Route
          path="/kozmetikusok"
          element={<DynamicLanding content={cosmeticsContent} />}
        />
        <Route
          path="/workshopok"
          element={<DynamicLanding content={workshopContent} />}
        />
        <Route
          path="/masszorok"
          element={<DynamicLanding content={massageContent} />}
        />
        <Route
          path="/kutyakozmetika"
          element={<DynamicLanding content={dogGroomingContent} />}
        />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Footer />
    </HelmetProvider>
  );
}

export default App;
